import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IRubricSectionDTO, RubricSectionDTO } from './rubric.section.dto';
import { IYearDTO, YearDTO } from './year.dto';

export interface IRubricDTO extends IBaseEntityDTO {
  year: IYearDTO;
  sections: IRubricSectionDTO[];
}

export class RubricDTO extends BaseEntityDTO implements IRubricDTO {
  year: IYearDTO;
  sections: IRubricSectionDTO[];
  constructor(data?: Partial<IRubricDTO>) {
    super(data);
    this.year = new YearDTO(data?.year);
    this.sections = data?.sections
      ? data.sections.map((section) => new RubricSectionDTO(section))
      : [];
  }
}
